<div *ngIf="!hideInfo && !utilizaDropComponent">
  <small class="timeline-panel-small">(<abbr title="máximo">máx.</abbr> de 10 imagens por item)</small>
</div>

<div *ngIf="utilizaDropComponent">
  <span>Selecione e anexe os documentos abaixo (opcional).</span>
  <a (click)="openModalFotoDica()" style="color: #ff720a;">Veja aqui dicas para uma boa foto.</a>
</div>

<div class="bg-gray" [class.pr30]="pr30" [class.pb30]="pr30">
  <ul class="required-documents">
    <li class="required-documents-item row" *ngFor="let docto of documentosAnexar; index as i">
      <app-upload-documentation-item
        *ngIf="docto.idPendencia !== Documentation.Report"
        (fileChange)="handleFileChange($event, i)"
        [files]="normalizedFileList[i]"
        [filesDocuments]="normalizedFileList"
        [document]="docto"
        [documentIndex]="i"
        (removeFileCallback)="removeFile(normalizedFileList[i], $event)"
        (removeAllFilesCallback)="removeAllFiles(normalizedFileList, i)"
        [acceptFiles]="acceptFiles"
        [timeline]="timeline"
      ></app-upload-documentation-item>

      <app-report-documentation-item
        *ngIf="docto.idPendencia === Documentation.Report"
        [document]="docto"
        [proposalId]="idFicha"
        [timeline]="timeline"
        (changeReport)="handleChangeReport($event)"
      ></app-report-documentation-item>
    </li>
  </ul>

  <section *ngIf="hasWarrantyPicturesDocument()">
    <p class="photos-title">Insira imagens do veículo:</p>

    <ul class="photos list-unstyled" style="height: 150px">
      <li>
        <app-upload-foto-garantia [timeline]="timeline" (fileChange)="fileGarantiaChange($event, 0)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia [timeline]="timeline" (fileChange)="fileGarantiaChange($event, 1)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia [timeline]="timeline" (fileChange)="fileGarantiaChange($event, 2)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>
    </ul>
  </section>

  <div>
    <div *ngIf="isDocsObrigatorio" class="alert alert-danger alert-dismissable">
      <strong>Anexar todos os documentos solicitados antes do envio</strong>
    </div>

    <div *ngIf="isSizeLimit" class="alert alert-danger alert-dismissable">
      <strong>Tamanho do arquivo não permitido - Limite: 10 Mb</strong>
    </div>

    <div *ngIf="!hideInfo && mensagem" class="alert alert-info alert-dismissable">
      <span class="martinT10" *ngIf="isEnviandoDocumento">
        <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
      </span>

      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>

      <strong>{{ mensagem }}</strong>
    </div>
  </div>

  <div *ngIf="!hideInfo && utilizaDropComponent">
      <small class="timeline-panel-small" style="text-align:center; margin-bottom: 10px;">(<abbr title="máximo">max.</abbr> de 10 imagens por item)</small>
    </div>

  <button *ngIf="!isOrigemSos && !hideSendButton && !utilizaDropComponent" class="btn btn-send send-doc martinT10" [ngClass]="{ 'enabled': validaEnvio(), 'centered': centeredSendButton }" (click)="sendDocuments()">{{ buttonLabel || 'Enviar Documentos' }}</button>
  <div class="btn-select-all">
      <button *ngIf="!isOrigemSos && !hideSendButton && utilizaDropComponent" class="btn btn-border-orange" (click)="openModalSelecionarTodosDocumentos()">{{ buttonLabel || 'Selecionar mais de um documento' }}</button>
  </div>

  <ng-content></ng-content>
</div>
